module.exports = __webpack_public_path__ + "static/img/14.13567f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour4/14.jpg
// module id = 3qRt
// module chunks = 0